import React, { useEffect, useRef, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;

const StatementOfInvestorCompaints = () => {
  const pageid = 18; // <-- static pageid
  const yearRefs = useRef({});
  const [statementofinvestor, setStatementOfInvestor] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch investor data
  useEffect(() => {
    const fetchInvestorData = async () => {
      try {
        const response = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
        const result = await response.json();
        console.log(BASE_URL)

        if (!result.success || !Array.isArray(result.data)) {
          setStatementOfInvestor([]);
          setLoading(false);
          return;
        }

        // Group reports by year_name
        const grouped = {};
        result.data.forEach((item) => {
          const year = item.year_name;
          if (!grouped[year]) grouped[year] = [];
          grouped[year].push({
            label: item.pdf_name,
            file: item.upload_file_path,
          });
        });

        // Convert grouped object to array and sort descending by year
        const finalData = Object.keys(grouped)
          .map((year) => ({
            year,
            reports: grouped[year],
          }))
          .sort((a, b) => b.year - a.year);

        setStatementOfInvestor(finalData);
      } catch (error) {
        console.error("Fetch failed:", error);
        setStatementOfInvestor([]);
      } finally {
        setLoading(false);
      }
    };

    fetchInvestorData();
  }, []);

  // Scroll to first year
  useEffect(() => {
    if (statementofinvestor.length > 0) {
      const el = yearRefs.current[statementofinvestor[0].year];
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  }, [statementofinvestor]);

  return (
    <>
      <Helmet>
        <title>Statement Of Investor Complaints | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      {/* Hero Section */}
      <div className="relative w-full">
        <img
          src="./imgs/investors/investorstatementcomplaints.png"
          alt="Chiripal Group Banner"
          className="object-cover w-full h-full md:h-[70vh] lg:h-[80vh] xl:h-[88vh]"
        />
        <div className="absolute  inset-0 bg-black bg-opacity-30 flex items-center">
          <div className="px-4 sm:px-8 md:px-24 lg:px-32">
            <h1 className="text-yellow-400 text-3xl sm:text-5xl md:text-6xl font-bold font-montserrat  ">
              Statement of Investor Complaints
            </h1>
          </div>
        </div>
      </div>


      {/* PDF Section */}
      <div className="py-12 px-4 max-w-7xl mx-auto font-signika">
        {loading ? (
          <p>Loading investor statements...</p>
        ) : statementofinvestor.length === 0 ? (
          <p>No investor statements found.</p>
        ) : (
          statementofinvestor.map((yearGroup, index) => (
            <div
              key={index}
              ref={(el) => (yearRefs.current[yearGroup.year] = el)}
              className="mb-10"
            >
              <h2 className="text-2xl font-extrabold text-[#0b3a6a] uppercase mb-4">
                For the Year {yearGroup.year}
              </h2>

              {yearGroup.reports.length === 0 ? (
                <p>No reports available for this year.</p>
              ) : (
                <ul className="list-disc pl-5 text-[#0b3a6a] font-medium space-y-2">
                  {yearGroup.reports.map((report, idx) => (
                    <li key={idx}>
                      <a
                      href={`${API_PDF_URL}/${report.file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:underline"
                      >
                        {report.label}
                      </a>
                    </li>
                  ))}
                </ul>
              )}

              <hr className="mt-4 border-gray-300" />
            </div>
          ))
        )}
      </div>

      <Footer />
    </>
  );
};

export default StatementOfInvestorCompaints;
